module.exports = __webpack_public_path__ + "fonts/kakaowebview-guide.png!static";